import { decode } from 'jsonwebtoken';

import { isEmpty } from 'lodash';

import {
  ELEMENTARY_SCHOOL_GRADES,
  MIDDLE_HIGH_SCHOOL_GRADES,
} from 'constants/gradeYears';
import getJwt from 'core/axios/getJwt';
import compareUserMode from 'utils/compareUserMode';

let token = getJwt();

let payload = {
  type: 'guest',
  ...((token && decode(token)) || {}),
};
const loginRedirect = localStorage.getItem('loginRedirect');
const studentPreviewCounselor = JSON.parse(
  localStorage.getItem('studentPreviewCounselor') || '{}',
);

const userType = payload.object_type || payload.type;
const isLoggedIn = userType !== 'guest';

// eslint-disable-next-line complexity
export default function user(
  state = {
    expiresAt: payload.exp,
    userId: null,
    type: userType, // guest|student|member|k12_admin|guardian
    activeUserType: userType, // guest|student|member|k12_admin|guardian
    id: payload.object_id, // related object table's pk, students.id, guardians.id
    schoolName: null,
    schoolId: null,
    defaultSchool: payload.default_transition_school_id,
    districtName: null,
    districtId: null,
    districtHashId: null,
    districtUuid: null,
    districtLogo: null,
    districtLocation: payload.district_location,
    districtAbbrev: null,
    firstName: null,
    lastName: null,
    preferredName: payload.preferred_name,
    currentStudentGrade: payload.current_grade,
    profilePic: null,
    email: null,
    studentId: null,
    studentPreviewCounselor:
      userType.includes('student') && !isEmpty(studentPreviewCounselor)
        ? studentPreviewCounselor
        : {},
    moduleAccess: {},
    loginRedirect,
    featureOnboarding: [],
    featureOnboardingModalOpen: false,
    loginFailureText: undefined,
    isCounselor: userType.includes('k12_admin'),
    isStudent: userType.includes('student'),
    isGuardian: userType.includes('guardian'),
    isLoggedIn,
    isLorWriter: userType.includes('recommender'),
    isSupervisor: userType.includes('supervisor'),
    isAlumni: payload?.is_alum,
    isMember: payload.is_member || userType.includes('member'),
    isCounselorAndGuardian:
      userType.includes('k12_admin') && userType.includes('guardian'),
    isSuperUser: payload.is_superuser,
    layout: {
      appBar: {
        left: [],
        right: [],
      },
      sideNav: [],
    },
    moduleAccessLoaded: false,
    sisId: null,
    studentNumber: null,
    userBooleans: [],
    userMode: '',
    mtpSchool: {},
    isDemoDistrict: false,
    grades: [],
    hasElementaryGrades: false,
    hasMiddleHighSchoolGrades: false,
    hasAllK12Grades: false,
    currentUserMode: null,
    userModes: [],
    phone: [],
  },
  action,
) {
  switch (action.type) {
    case 'UPDATE_USER_MODE':
      return {
        ...state,
        userMode: action.userMode,
      };
    case 'UPDATE_USER_TYPES':
      return {
        ...state,
        type: action.userTypesData.userType,
        activeUserType: action.userTypesData.activeUserType,
        isAlumni: action.userTypesData.isAlumni,
      };
    case 'POPULATE_K12_ADMIN_GRADES':
      return {
        ...state,
        grades: action.grades,
        hasElementaryGrades: action.grades.some(grade =>
          ELEMENTARY_SCHOOL_GRADES.includes(grade),
        ),
        hasMiddleHighSchoolGrades: action.grades.some(grade =>
          MIDDLE_HIGH_SCHOOL_GRADES.includes(grade),
        ),
      };
    case 'POPULATE_USER_CONTEXT':
      return {
        ...state,
        moduleAccess: action.moduleAccess,
        userCapabilities: action.userCapabilities,
        layout: action.layout,
        userModes: action.userModes,
        currentUserMode: action.currentUserMode,
        isMember: compareUserMode(action.currentUserMode, 'member', state.type),
        isGuardian: compareUserMode(
          action.currentUserMode,
          'guardian',
          state.type,
        ),
        isCounselor: compareUserMode(
          action.currentUserMode,
          'k12_admin',
          state.type,
        ),
      };
    case 'POPULATE_USER_MODULE_ACCESS':
      return {
        ...state,
        moduleAccess: {
          ...state.moduleAccess,
          ...action.moduleAccess,
        },
      };
    case 'UPDATE_PROFILE_PIC':
      return {
        ...state,
        profilePic: action.picture,
      };
    case 'UPDATE_LOGIN_REDIRECT':
      if (action.data) {
        localStorage.setItem('loginRedirect', action.data);
      } else {
        localStorage.removeItem('loginRedirect');
      }
      return {
        ...state,
        loginRedirect: action.data,
      };
    case 'UPDATE_PREFERRED_NAME':
      return {
        ...state,
        preferredName: action.preferredName,
      };
    case 'DECODE_TOKEN': {
      token = getJwt();
      payload = {
        type: 'guest',
        ...((token && decode(token)) || {}),
      };
      const type = payload.object_type || payload.type;
      return {
        ...state,
        expiresAt: payload.exp,
        userId: payload.user_id,
        type, // guest|student|member|k12_admin|guardian
        activeUserType: type, // guest|student|member|k12_admin|guardian
        id: payload.object_id, // related object table's pk, students.id, guardians.id
        defaultSchool: payload.default_transition_school_id,
        isGuardian: type.includes('guardian'),
        moduleAccess: {},
        loginRedirect,
        isAlumni: payload.is_alum,
      };
    }
    case 'UPDATE_EXP_TIME': {
      token = getJwt();
      payload = {
        type: 'guest',
        ...((token && decode(token)) || {}),
      };
      return {
        ...state,
        expiresAt: payload.exp,
      };
    }
    case 'POPULATE_FEATURE_ONBOARDING':
      return {
        ...state,
        featureOnboarding: action.data,
      };
    case 'SET_FEATURE_ONBOARDING_MODAL_OPEN':
      return {
        ...state,
        featureOnboardingModalOpen: action.featureOnboardingModalOpen,
      };
    case 'SET_LOGIN_FAILURE_TEXT':
      return {
        ...state,
        loginFailureText: action.text,
      };

    case 'SET_MODULE_ACCESS_LOADED':
      return {
        ...state,
        moduleAccessLoaded: true,
      };

    case 'POPULATE_ORGANIZATION_CONTEXT':
      return {
        ...state,
        affiliations: action.data.affiliations,
        memberUuid: action.data.memberUuid,
      };

    case 'POPULATE_USER_BOOLEANS':
      return {
        ...state,
        userBooleans: action.data,
      };

    case 'POPULATE_MTP_SCHOOL':
      return {
        ...state,
        mtpSchool: action.data,
      };

    case 'POPULATE_ALUMNI_INFO':
      return {
        ...state,
        isAlumniInfoLoading: false,
        alumniInfo: action.data,
      };

    case 'SET_ALUMNI_INFO_LOADING':
      return {
        ...state,
        isAlumniInfoLoading: true,
      };

    case 'RESET_USER_CONTEXT':
      return {
        expiresAt: undefined,
        userId: undefined,
        type: 'guest',
        activeUserType: 'guest',
        id: undefined,
        schoolName: undefined,
        schoolId: undefined,
        defaultSchool: undefined,
        districtName: undefined,
        districtId: undefined,
        districtUuid: undefined,
        districtLogo: undefined,
        districtLocation: undefined,
        districtAbbrev: undefined,
        firstName: undefined,
        lastName: undefined,
        preferredName: undefined,
        currentStudentGrade: undefined,
        coursePlannerAccess: false,
        profilePic: undefined,
        email: undefined,
        studentId: undefined,
        studentPreviewCounselor: {},
        moduleAccess: {},
        loginRedirect: undefined,
        featureOnboarding: [],
        featureOnboardingModalOpen: false,
        loginFailureText: undefined,
        isCounselor: undefined,
        isStudent: undefined,
        isGuardian: undefined,
        isLorWriter: undefined,
        isSupervisor: undefined,
        isAlumni: undefined,
        isMember: undefined,
        layout: {
          appBar: {
            left: [],
            right: [],
          },
          sideNav: [],
        },
        moduleAccessLoaded: true,
        sisId: undefined,
        studentNumber: undefined,
        userBooleans: [],
        userMode: '',
        mtpSchool: {},
        isDemoDistrict: undefined,
        phone: undefined,
      };

    case 'POPULATE_USER_DETAILS':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
